/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_item = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item" | "TradeOnboardingCoachmarkConditionalLoader_item" | "PdpRespTradeOnApprovalCoachmarkLoader_item">;
    readonly " $refType": "PdpSharedContactDealerButton_item";
};
export type PdpSharedContactDealerButton_item$data = PdpSharedContactDealerButton_item;
export type PdpSharedContactDealerButton_item$key = {
    readonly " $data"?: PdpSharedContactDealerButton_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedContactDealerButton_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTradeOnApprovalCoachmarkLoader_item",
      "args": null
    }
  ]
};
(node as any).hash = 'b6d88fb697028e1a787220019b7f1e0e';
export default node;
